import { Container } from "@mui/material";
import Page from "../components/Page";
import { PipelineInstanceLayout } from "../features/pipeline-instance";

export default function PipelineInstancePage() {
    return (
        <Page title="Pipeline Instance | HCC">
            <Container maxWidth="xl">
                <PipelineInstanceLayout />
            </Container>
        </Page>
    );
}
